export default {
  "NOTIFICATIONS": "नोटिफ़िकेशन्स",
  "NOTIFICATION": "नोटिफ़िकेशन"
};
